export const getStyles = (theme: any) => ({
  styles: {
    title: {
      color: theme.palette.grey[0],
      fontSize: "24px",
      lineHeight: "32px",
    },

    buttons: {
      display: "flex",
      marginTop: "30px",
    },
    button: {
      backgroundColor: theme.palette.grey[700],
      borderRadius: "100px",
      border: "none",
      color: theme.palette.grey[0],
      cursor: "pointer",
      fontSize: "14px",
      width: "205px",
      height: "56px",

      "&:hover": {
        backgroundColor: theme.palette.grey[700],
        opacity: 1,
      },

      "&:disabled": {
        color: theme.palette.grey[500],
      },
    },
    refreshButton: {
      margin: '0 50px',
    },
    image: {
      borderRadius: "8px",
      width: "82px",
      height: "116px",
      marginRight: "16px",
    },
    answers: {
      alignItems: "center",
      display: "flex",
      margin: "10px 0",
    },
  },
});
